import React from 'react'
import { SessionProvider } from '@crunchyroll/cr-static-shared-components'

import { PlayerProvider } from '@contexts/PlayerContext'

const wrapRoot = ({ element }) => 
<SessionProvider>
  <PlayerProvider>{element}</PlayerProvider>
</SessionProvider>

export default wrapRoot